import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { purgeEntities } from "../../io/entity/store/entity.actions";
import { BiometricAccessService } from "../../services/biometric-access.service";
import { Store } from "@ngrx/store";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorPageComponent {
  public errorString = "";
  public errorHeadlineString = "";

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _biometricAccessService: BiometricAccessService,
    private _router: Router,
    private _store: Store
  ) {}

  ngOnInit() {
    this._store.dispatch(purgeEntities());
    this._activatedRoute.queryParams.subscribe((params) => {
      const error = params["error"] ? params["error"] : "default";

      this.errorHeadlineString = "ERROR." + error + ".HEADLINE";
      this.errorString = "ERROR." + error + ".MESSAGE";
    });
  }

  public retry() {
    this._router.navigateByUrl("/app/dashboard");
  }
}
